import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import Work from '../../Assets/work.png';

export default function HowWeWork() {
    return (
        <Container className="work-section py-5">

            <Row>

                {/* LEFT SIDE */}
                <Col md={6} className="d-flex flex-column justify-content-between">
                    <div>
                        <h2 className="heading-style-h2 pb-3">How We <span className="text-gradient-1">Work</span></h2>
                        <h5 className='heading-style-h5 pb-5'>A clear way of working that keeps delivery predictable and easy to manage from start to finish.</h5>
                    </div>
                    <Image src={Work} className="img-fluid" />
                </Col>

                {/* RIGHT SIDE TIMELINE */}
                <Col md={6} className="worksteps-wrapper ps-5">

                    <div className="worksteps">

                        {/* Item 1 */}
                        <div className="work-step">
                            <div className="number"><h2 className="heading-style-h2 text-gradient-1">01</h2></div>
                            <div className="content py-4">
                                <h5 className='heading-style-h5 pb-3'>Understand the Context</h5>
                                <p>
                                    We focus on getting things right at the engineering level, not
                                    just delivering outcomes
                                </p>
                            </div>
                        </div>

                        {/* Item 2 */}
                        <div className="work-step">
                            <div className="number"><h2 className="heading-style-h2 text-gradient-1">02</h2></div>
                            <div className="content py-4">
                                <h5 className='heading-style-h5 pb-3'>Align with Your Team</h5>
                                <p>
                                    We integrate into your workflows, working alongside your team, supported by offshore development teams and clear delivery practices
                                </p>
                            </div>
                        </div>

                        {/* Item 3 */}
                        <div className="work-step">
                            <div className="number"><h2 className="heading-style-h2 text-gradient-1">03</h2></div>
                            <div className="content py-4">
                                <h5 className='heading-style-h5 pb-3'>Execute with Structure</h5>
                                <p>
                                    Clear processes, predictable delivery and consistent
                                    communication
                                </p>
                            </div>
                        </div>

                        {/* Item 4 */}
                        <div className="work-step">
                            <div className="number"><h2 className="heading-style-h2 text-gradient-1">04</h2></div>
                            <div className="content py-4 pb-0">
                                <h5 className='heading-style-h5 pb-3'>Focus on What Lasts</h5>
                                <p>
                                    We prioritise stability, performance and long-term outcomes
                                </p>
                            </div>
                        </div>

                    </div>

                </Col>

            </Row>

        </Container>
    );
}